import React, { useContext, useState} from 'react';
import {IProps} from './types';
import * as S from './styles';
import { Context } from '@routes/private/Editor/Context';
import Slider, { Range } from 'rc-slider';
import ZoomMinusIcon from '@assets/icons/zoomMinusIcon';
import ZoomPlusIcon from '@assets/icons/zoomPlusIcon';
import HandIcon from '@assets/icons/handIcon';
import Tooltip from '@components/Tooltip';
import AddArtboardIcon from '@assets/icons/addArtboardIcon';
import CreateNew from '@routes/private/Studio/components/CreateNew';
import AddArtboard from './AddArtboard';
import Zoom from './Zoom';
import GridOverlay from './GridOverlay';

const InnerToolBar: React.FC<IProps> = (props) => {
  const { onZoomChange, editorStatus, onDraggingChange } = useContext(Context);
  const [addArtboard, setAddArtboard]= useState(false);  

  const handleAddArtboard=()=>{
    setAddArtboard(!addArtboard);
  }
  return (
    <>
    <S.Root>
      <GridOverlay></GridOverlay>
      <AddArtboard></AddArtboard>      
      <S.Drag onClick={()=> onDraggingChange(!editorStatus.dragging)} dragging={editorStatus.dragging}>
        <HandIcon fillColor={editorStatus.dragging ? "white" :"#818181"}/>
      </S.Drag>
      <Zoom></Zoom>
    </S.Root>
    {
      addArtboard && 
      <CreateNew position='right' addArtboard={addArtboard} setAddArtboard={(add:boolean)=> setAddArtboard(add)}
      ></CreateNew>
    }
    </>
  );
}
  
export default InnerToolBar;